/* Imports */
import { API_HELPER } from "@/helpers/api.js";

/* Exports */
// API services that can be invoked on the modules
export const FAVORITES_SERVICE = {postFavoriteBySlug, deleteFavoriteBySlug, getFavorites};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Favorites";

/* Services */
//Service to add items to favorites
function postFavoriteBySlug(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to remove items from favorites
function deleteFavoriteBySlug(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'DELETE'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to list favorites
function getFavorites(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET'
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}

